import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { CsvImportUpload } from '../../shared/models/csv-import.model';
import { AuthorizationBase } from '../../shared/libraries/authorize-base';

@Injectable({
  providedIn: "root"
})
export class CsvImportService extends AuthorizationBase{
  private accountBaseRoute: string;

  constructor(private httpClient: HttpClient) {
    super();
    this.accountBaseRoute = environment.accountAPIRoot;

  }

  upload(payload: CsvImportUpload, type: string) {
    payload.ApplicationUserId = super.userId().toString();
    switch (type) {
      case "item":
        return this.httpClient.post(environment.inventoryAPIRoot + '/item/import', payload);
      case "customer":
        return this.httpClient.post(environment.customerAPIRoot + '/customer/import', payload);
      case "invoice":
        return this.httpClient.post(environment.invoiceAPIRoot + '/import', payload);
    }
  }

  runningimports(type: string) {
    return this.httpClient.get(environment.accountAPIRoot + '/' + type + '/import/in-progress/count/' + super.userId());
  }

  completedimports(type: string) {
    return this.httpClient.get(environment.accountAPIRoot + '/' + type + '/import/completed/count/' + super.userId());
  }

  importResults(type: string) {
    return this.httpClient.get(environment.accountAPIRoot + '/' + type + '/import/completed/' + super.userId());
  }

  importQueueResults(queueId: number) {
    return this.httpClient.get(environment.accountAPIRoot + '/import/results/' + queueId);
  }

  validateCsv(payload: any, type: string, headerRow: number){
    return this.httpClient.post(environment.accountAPIRoot + `/dataimport/csv/read/${type}?headerRow=${headerRow}`, payload);
  }

  importColumns(type: string) {
    return this.httpClient.get(environment.accountAPIRoot + `/import/columns/${type}`);
  }

  importInvoiceDBColumns() {
    return this.httpClient.get(environment.accountAPIRoot + '/import/invoice/columns/');
  }

  mapCsvDBColumns(payload: any, type: string, headerRow: number, id: string){
    return this.httpClient.post(environment.accountAPIRoot + `/dataimport/csv/mapping/read/${type}?headerRow=${headerRow}&id=${id}`, payload);
  }
  
}
